"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GBETUtils = void 0;
// eslint-disable-next-line @typescript-eslint/no-namespace
var GBETUtils;
(function (GBETUtils) {
    GBETUtils.createUUID = (a) => a
        ? ((Number(a) ^ (Math.random() * 16)) >> (Number(a) / 4)).toString(16)
        : `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, GBETUtils.createUUID);
    GBETUtils.urlencode = (str) => {
        str = encodeURIComponent(str);
        str = str.replace(/\+/g, '%2B');
        str = str.replace('%20', '+');
        str = str.replace('*', '%2A');
        str = str.replace(/'/g, '%2F');
        str = str.replace('@', '%40');
        return str;
    };
    GBETUtils.getCookie = (c_name) => {
        if (document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + '=');
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(';', c_start);
                if (c_end == -1)
                    c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return '';
    };
    GBETUtils.setCookie = (c_name, value, expiredays, sameSite) => {
        let expiry = '';
        let domain = getTopDomain();
        if (domain.indexOf('.') > -1)
            domain = ';domain=.' + domain;
        else
            domain = ''; //to support non localhost
        if (expiredays !== undefined) {
            const exdate = new Date();
            exdate.setTime(exdate.getTime() + 60000 * 60 * 24 * expiredays);
            expiry = ';expires=' + exdate.toUTCString();
        }
        const sameSiteFlag = sameSite === undefined ? '' : 'SameSite=' + sameSite + ';';
        try {
            document.cookie =
                c_name +
                    '=' +
                    escape(value) +
                    expiry +
                    domain +
                    ';secure;path=/;' +
                    sameSiteFlag;
        }
        catch (ex) {
            console.warn('Error setting cookie: ' +
                c_name +
                '=' +
                escape(value) +
                expiry +
                domain +
                ';secure;path=/;' +
                sameSiteFlag);
            console.warn(ex);
        }
        if (sameSite === 'None' && GBETUtils.getCookie(c_name) !== value) {
            console.warn('Cookie ' +
                c_name +
                ' was not created (with SameSite=None), this can happen in some legacy browsers, trying again without SameSite=None');
            // Setting cookie with "SameSite=None" can fail in some legacy browsers.
            // So if cookie is not set, then try again without "SameSite=None".
            try {
                document.cookie =
                    c_name + '=' + escape(value) + expiry + domain + ';secure;path=/;';
            }
            catch (ex) {
                console.warn('Error setting cookie: ' +
                    c_name +
                    '=' +
                    escape(value) +
                    expiry +
                    domain +
                    ';secure;path=/;');
                console.warn(ex);
            }
            if (GBETUtils.getCookie(c_name) !== value) {
                console.warn('Cookie ' + c_name + ' was not created (without SameSite=None)');
            }
        }
    };
    GBETUtils.deleteCookie = (c_name) => {
        const exdate = new Date();
        let domain = getTopDomain();
        if (domain.indexOf('.') > -1)
            domain = ';domain=.' + domain;
        else
            domain = ''; //to support non localhost
        exdate.setDate(exdate.getDate() - 1);
        try {
            document.cookie =
                c_name +
                    '=' +
                    ';expires=' +
                    exdate.toUTCString() +
                    domain +
                    ';secure;path=/;';
        }
        catch (ex) {
            console.warn('Error deleting cookie: ' + c_name);
            console.warn(ex);
        }
        if (GBETUtils.getCookie(c_name) !== '') {
            console.warn('Cookie was not deleted. Trying again with "SameSite=None"');
            try {
                document.cookie =
                    c_name +
                        '=' +
                        ';expires=' +
                        exdate.toUTCString() +
                        domain +
                        ';secure;path=/;SameSite=None';
            }
            catch (ex) {
                console.warn('Error deleting cookie: ' + c_name + ' (with SameSite=None)');
                console.warn(ex);
            }
            if (GBETUtils.getCookie(c_name) !== '') {
                console.warn('Cookie was not deleted (with "SameSite=None")');
            }
        }
    };
    const getTopDomain = () => {
        const domain = document.domain;
        const domainParts = domain.split('.');
        let topDomain = '';
        let partCount = 0;
        for (let i = domainParts.length - 1; i >= 0; i--) {
            partCount++;
            topDomain = domainParts[i] + '.' + topDomain;
            if (partCount > 1 && domainParts[i] !== 'co')
                break;
        }
        return topDomain.substring(0, topDomain.length - 1);
    };
})(GBETUtils || (exports.GBETUtils = GBETUtils = {}));
